/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useLayoutEffect } from 'react';
import { Helmet } from 'react-helmet';
import Banner from './Banner/Banner';
import CoreValue from './CoreValue/CoreValue';
import Principle from './Principle/Principle';

import { useSetRecoilState } from 'recoil';
import { isHeaderBlackState } from '../../store/atoms';

import styled from 'styled-components';
import Benefits from './Benefits/Benefits';

export default function About() {
  const setIsHeaderBlackState = useSetRecoilState(isHeaderBlackState);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useLayoutEffect(() => {
    setIsHeaderBlackState(false);
  }, []);

  return (
    <>
      <Helmet>
        <meta property="og:description" content="인텔리퀀트의 비전과 가치" />
        <meta name="description" content="인텔리퀀트의 비전과 가치" />
      </Helmet>
      <StyledAbout>
        <Banner />
        <CoreValue />
        <Principle />
        <Benefits />
      </StyledAbout>
    </>
  );
}

const StyledAbout = styled.section`
  margin-top: 83px;

  ${({ theme }) => theme.mobile`
    margin-top: 0;
    text-align: center;
  `}
`;
